import React from "react";

export function PageHeader({ title, description, actions, children }) {
  return (
    <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between mb-6">
      <div className="min-w-0">
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-slate-900" data-testid="page-title">
          {title}
        </h1>
        {description && <p className="mt-1 text-sm text-slate-500 max-w-2xl">{description}</p>}
        {children}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2 lg:shrink-0">{actions}</div>}
    </div>
  );
}
